// @flow

import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import Stack from './layout/Stack'

type Props = {|
  loadingText?: string
|}

type State = {|
  showSlowConnectionMessage: boolean
|}

class LoadingIndicator extends Component<Props, State> {
  timer: TimeoutID

  state = {
    showSlowConnectionMessage: false
  }

  componentDidMount () {
    this.timer = setTimeout(() => {
      this.setState({ showSlowConnectionMessage: true })
    }, 5000)
  }

  componentWillUnmount () {
    clearTimeout(this.timer)
  }

  render () {
    return (
      <div style={styles.wrapper}>
        <Stack align='center'>
          <FontAwesome name='circle-o-notch fa-spin' style={styles.icon} />
          <p style={styles.text}>{this.props.loadingText || 'Loading'}...</p>
          {this.state.showSlowConnectionMessage && <p style={styles.text}>{`If you're on a slow connection this might take a while...`}</p>}
        </Stack>
      </div>
    )
  }
}

const styles = {
  wrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto'
  },
  icon: {
    fontSize: '5.6rem',
    color: 'var(--color-cool-grey-50)'
  },
  text: {
    fontsize: '1.6rem',
    color: 'var(--color-cool-grey-50)',
    marginBottom: 0
  }
}

export default LoadingIndicator
